import {Row, Col, Alert, Select} from "antd";
import {useEffect, useState} from "react";
import {useParams, useLocation} from "react-router-dom";
import {useGetCustomer} from "../../../../react-query-hooks/customer";
import {FullPageLoader} from "../../../full-page-loader";
import {CustomerMetricsSkeleton} from "../../customer-details-section/customer-metrics-skeleton";
import {StyledInfoItem} from "./info-section.style";

const {Option} = Select;

const InfoSection = () => {
  const {id} = useParams();
  const location = useLocation();
  const getCustomerQuery = useGetCustomer(id);
  const customerNameFromState = (location.state as {customerName?: string})?.customerName;
  const revenueByCurrency = getCustomerQuery.data?.revenueByCurrency ?? {};
  const currencies = Object.keys(revenueByCurrency);
  const [selectedCurrency, setSelectedCurrency] = useState<string>("");

  useEffect(() => {
    if (currencies.length > 0 && !currencies.includes(selectedCurrency)) {
      setSelectedCurrency(currencies[0]);
    }
  }, [currencies, selectedCurrency]);

  if (getCustomerQuery.isLoading) {
    return <FullPageLoader />;
  }
  if (getCustomerQuery.isError) {
    return (
      <Alert
        message="Error"
        description={getCustomerQuery.error.message}
        type="error"
        showIcon
      />
    );
  }
  return (
    <>
      {getCustomerQuery.isFetching ? (
        <CustomerMetricsSkeleton />
      ) : (
        <Row gutter={[32, 20]}>
          <Col span={24} md={8}>
            <StyledInfoItem>
              <p className="info-title">Name</p>
              <p className="info-value">
                {customerNameFromState ?? getCustomerQuery.data.name}
              </p>
            </StyledInfoItem>
          </Col>
          <Col span={24} md={8}>
            <StyledInfoItem>
              <p className="info-title">Email address</p>
              <p className="info-value">{getCustomerQuery.data.emailAddress}</p>
            </StyledInfoItem>
          </Col>
          {getCustomerQuery.data.phoneNumber && (
            <Col span={24} md={8}>
              <StyledInfoItem>
                <p className="info-title">Phone number</p>
                <p className="info-value">{getCustomerQuery.data.phoneNumber}</p>
              </StyledInfoItem>
            </Col>
          )}

          <Col span={24} md={8}>
            <StyledInfoItem>
              <p className="info-title">Number of purchases</p>
              <p className="info-value">{getCustomerQuery.data.numberOfPurchases}</p>
            </StyledInfoItem>
          </Col>
          <Col span={24} md={8}>
            <StyledInfoItem>
              <p className="info-title">Total volume</p>
              {currencies.length > 1 ? (
                <div style={{display: "flex", alignItems: "center", gap: "0.8rem"}}>
                  <Select
                    value={selectedCurrency || undefined}
                    onChange={setSelectedCurrency}
                    style={{minWidth: 80}}
                    size="small"
                  >
                    {currencies.map((code) => (
                      <Option key={code} value={code}>
                        {code}
                      </Option>
                    ))}
                  </Select>
                  <span>
                    {selectedCurrency
                      ? Number(revenueByCurrency[selectedCurrency] ?? 0).toLocaleString()
                      : "-"}
                  </span>
                </div>
              ) : currencies.length === 1 ? (
                <p className="info-value">
                  {currencies[0]}{" "}
                  {Number(revenueByCurrency[currencies[0]] ?? 0).toLocaleString()}
                </p>
              ) : (
                <p className="info-value">{getCustomerQuery.data.totalVolume}</p>
              )}
            </StyledInfoItem>
          </Col>
        </Row>
      )}
    </>
  );
};

export {InfoSection};
